import md5 from 'js-md5'
import Toast from 'muse-ui-toast'
const TokenKey = 'H5-Token'
const SessionKey = 'H5-Session'
const MobileDetect = require('@/assets/js/mobile-detect')

/**
 * 获取异常文件
 * @param Do
 * @returns {Array}
 */
export function signDo (Do) {
  const timestamp = Math.round(new Date().getTime() / 1000)
  let sign = 'h5.tanwan.com'
  if (process.env.VUE_APP_UITYPE === '6') {
    sign = 'f392df04b7686b96e8fdaaf21c2f4848'
  }
  if (process.env.VUE_APP_UITYPE === '7') {
    sign = 'NEgYIgiTaecTiLDEPJCPxHJKvUMUgGWJ'
  }
  const res = md5(md5(`${sign}${Do}`) + timestamp)
  return [res, timestamp]
}
/**
 * 统一返回报错信息
 * @param error
 * @returns {Object}
 */
export function returnMsg () {
  const res = {
    error_code: 500,
    msg: '请求错误'
  }
  return res
}

/**
 * 获取token
 */
export function getToken () {
  const TokenKey = 'H5-Token'
  if (window.tracelessToken) {
    return window.tracelessToken
  } else {
    return localStorage.getItem(TokenKey)
  }
}

/**
 * 设置token
 * @param token
 */
export function setToken (token) {
  try {
    localStorage.setItem(TokenKey, token)
  } catch (e) {
    if (e.code === 22) {
      window.tracelessToken = token
    }
  }
}

/**
 * 清除token
 */
export function removeToken () {
  try {
    localStorage.removeItem(TokenKey)
  } catch (e) {
    if (e.code === 22) {
      window.tracelessToken = null
    }
  }
}

export function getSession () {
  const SessionKey = 'H5-Session'
  if (window.tracelessSession) {
    return window.tracelessSession
  } else {
    return localStorage.getItem(SessionKey)
  }
}

export function setSession (session) {
  try {
    localStorage.setItem(SessionKey, session)
  } catch (e) {
    if (e.code === 22) {
      window.tracelessSession = session
    }
  }
}

export function removeSession () {
  try {
    localStorage.removeItem(SessionKey)
  } catch (e) {
    if (e.code === 22) {
      window.tracelessSession = null
    }
  }
}

/**
 * 拖拽
 */
export function moveDiv (div1) {
  // 调整位置后重置悬浮球位置
  div1.style.left = '84%'
  div1.style.top = '65%'
  var maxW = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - div1.offsetWidth
  var maxH = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - div1.offsetHeight
  var oL = 0
  var oT = 0

  // 手指触摸开始，记录div的初始位置
  div1.addEventListener('touchstart', function (e) {
    var ev = e || window.event
    var touch = ev.targetTouches[0]
    oL = touch.clientX - div1.offsetLeft
    oT = touch.clientY - div1.offsetTop
    document.addEventListener('touchmove', defaultEvent, false)
  })
  // 触摸中的，位置记录
  div1.addEventListener('touchmove', function (e) {
    var ev = e || window.event
    var touch = ev.targetTouches[0]
    var oLeft = touch.clientX - oL
    var oTop = touch.clientY - oT
    if (oLeft < 0) {
      oLeft = 0
    } else if (oLeft >= maxW) {
      oLeft = maxW
    }
    if (oTop < 0) {
      oTop = 0
    } else if (oTop >= maxH) {
      oTop = maxH
    }

    div1.style.left = oLeft + 'px'
    div1.style.top = oTop + 'px'
  })
  // 触摸结束时的处理
  div1.addEventListener('touchend', function () {
    document.removeEventListener('touchmove', defaultEvent)
  })

  // 阻止默认事件
  function defaultEvent (e) {
    e.preventDefault()
  }
}
/**
 *
 * @param {Promise} promise
 * @param {Object} params
 * @return {Promise}
 */
export function newPromise (promise, params) {
  const PM = promise
  return new Promise((resolve, reject) => {
    PM(params).then(res => {
      resolve(res.data)
    }).catch(() => {
      resolve(returnMsg())
    })
  })
}

export const h5SwapSDK = {
  chkFrom (from) { //  交换包
    return from === 'h5_swap'
  },
  urlencode (str) {
    str = (str + '').toString()
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+')
  }
}

export const h5IosWapSdk = {
  chkFrom (from) {
    return from === 'ios_wap'
  },
  pay (payUrl) {
    var payData = {
      strInfo: payUrl
    }

    if (typeof window.initGameCall === 'function') {
      return window.initGameCall(payData)
    } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.initGameCall === 'object') {
      return window.webkit.messageHandlers.initGameCall.postMessage(payData)
    }

    Toast.error('支付方法异常')
  },
  payApple (payData) {
    if (typeof window.initGameCall === 'function') {
      return window.initGameCall(payData)
    } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.initGameCall === 'object') {
      return window.webkit.messageHandlers.initGameCall.postMessage(payData)
    }

    Toast.error('支付方法异常')
  }
}

export const wx = {
  wxJsPay (payInfo, _this) {
    if (typeof window.WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', function () {
          this._wxJsPay(payInfo, _this)
        }, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', function () {
          this._wxJsPay(payInfo, _this)
        })
        document.attachEvent('onWeixinJSBridgeReady', function () {
          this._wxJsPay(payInfo, _this)
        })
      }
    } else {
      this._wxJsPay(payInfo, _this)
    }
  },
  _wxJsPay (payInfo, _this) {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
      'appId': payInfo.appId, // 公众号名称，由商户传入
      'timeStamp': payInfo.timeStamp, // 时间戳，自1970 年以来的秒数
      'nonceStr': payInfo.nonceStr, // 随机串
      'package': payInfo.package,
      'signType': payInfo.signType, // 微信签名方式:
      'paySign': payInfo.paySign // 微信签名
    }, function (res) {
      _this.payDialog = false
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        _this.$toast.success('支付成功')
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        _this.$toast.error('取消支付')
      } else {
        _this.$toast.error('请确认在手机微信浏览器里打开')
      }
    })
  }
}

export function InitMobileInfo () {
  const mobileInfo = {
    os: false,
    model: false,
    version: false,
    phone: false
  }

  var deviceType = navigator.userAgent // 获取userAgent信息
  var md = new MobileDetect(deviceType)// 初始化mobile-detect

  var os = md.os()
  mobileInfo.model = md.mobile() ? md.mobile() : '0'
  mobileInfo.phone = md.phone() ? md.phone() : 'null'

  if (os === 'iOS') { // ios系统的处理
    mobileInfo.os = 'ios'
    mobileInfo.version = md.version('iPhone') ? md.version('iPhone') : ''
  } else if (os === 'AndroidOS') { // Android系统的处理
    mobileInfo.os = 'android'
    mobileInfo.version = md.version('Android')
    var uAgent = deviceType.split(';')
    uAgent.findIndex(item => {
      if (item.indexOf('Build/')) {
        mobileInfo.model = item.substring(0, item.indexOf('Build/'))
      }
    })
  } else {
    mobileInfo.os = os || 'adnroid'
    mobileInfo.version = md.version('Android') ? md.version('Android') : '0'
  }
  return mobileInfo
}
